import { ref } from '@vue/runtime-dom'
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'orgName',
      label: '资产公司',
      width: '140'
    },
    {
      key: 'carNo',
      label: '车牌号',
      width: '140'
    },
    {
      key: 'plateType',
      label: '号牌种类',
      width: '140'
    },
    {
      key: 'retirementTime',
      label: '强制报废日期',
      width: '160',
      slot: 'retirementTime'
    },
    {
      key: 'validityDeadline',
      label: '检验有效期',
      width: '160',
      slot: 'validityDeadline'
    },
    {
      key: 'carState',
      label: '车辆状态',
      width: '160'
    },
    {
      key: 'mortgageState',
      label: '抵押状态',
      width: '140'
    },
    {
      key: 'violationCount',
      label: '未处理违章数',
      width: '100'
    },
    {
      key: 'lastViolationSyncTime',
      label: '上次违章同步时间',
      width: '160'
    },
    {
      key: 'lastViolationTime',
      label: '最新违章时间',
      width: '160'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160'
    },
    {
      key: 'updateTime',
      label: '修改时间',
      width: '160'
    },
    // {
    //   key: 'nextViolationSyncTime',
    //   label: '下次违章同步时间',
    //   width: '160'
    // },

    {
      key: 'action',
      label: '操作',
      width: '110',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any, remoteData2: any) => [
  {
    type: 'select',
    label: '资产公司',
    key: 'settingId',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'select',
    label: '车牌号',
    key: 'carNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 8,
    options: remoteData2.options,
    isLoading: remoteData2.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData2.remoteMethod,
    rules: {
    }
  },
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}